import { FormlyFieldConfig } from '@ngx-formly/core';

export function RequiredValidatorMessage(err, field: FormlyFieldConfig) {
  return `"${field.props.label}" alanı zorunludur`;
}
